import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import PropertyCard from "@/components/PropertyCard";
import { useLang, useSiteSettings } from "@/context/LanguageContext";
import { isNewProperty } from "@/components/NewBadge";

// Startseite: „Neu bei uns“ – zuletzt online gegangene Objekte (Einstellung new_home_strip + new_badge_days)
export const newProperties = (properties, days) => properties.filter((p) => isNewProperty(p, Number(days))).sort((a, b) => (b.online_since || "").localeCompare(a.online_since || ""));

export const NewPropertiesSection = ({ properties, limit = 3 }) => {
  const { t } = useLang();
  const site = useSiteSettings();
  if (site.new_home_strip === false) return null;
  const list = newProperties(properties, site.new_badge_days ?? 30);
  if (!list.length) return null;
  const cols = limit <= 3 ? "md:grid-cols-3" : "md:grid-cols-3 xl:grid-cols-4";
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 home-section border-t border-stone-200" data-testid="new-properties-section">
      <div className="flex items-end justify-between home-section-head gap-6 flex-wrap">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#8f6a14] flex items-center gap-2"><Sparkles className="w-4 h-4" />{t.newSection.subtitle}</div>
          <h2 className="font-serif text-4xl md:text-5xl text-stone-900 mt-3">{t.newSection.title}</h2>
        </div>
        {list.length > limit && (
          <Link to="/properties?new=1" className="text-sm text-brand underline underline-offset-4 hover:text-brand-hover" data-testid="new-properties-all">{t.newSection.all} →</Link>
        )}
      </div>
      <div className={`grid ${cols} gap-6`}>
        {list.slice(0, limit).map((p) => <PropertyCard key={p.id} property={p} />)}
      </div>
    </section>
  );
};
